import { render, staticRenderFns } from "./Navbar.GoToTop.vue?vue&type=template&id=1f70fee2&scoped=true&"
import script from "./Navbar.GoToTop.vue?vue&type=script&lang=js&"
export * from "./Navbar.GoToTop.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.GoToTop.vue?vue&type=style&index=0&id=1f70fee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70fee2",
  null
  
)

export default component.exports